(() => {
  "use strict";

  const root = document.querySelector(
    "[data-christ-event-landing]"
  );

  if (!root || root.dataset.initialized === "true") {
    return;
  }

  root.dataset.initialized = "true";

  const form = root.querySelector(
    "[data-calculator-form]"
  );

  const resultBox = root.querySelector(
    "[data-calculator-result]"
  );

  const errorBox = root.querySelector(
    "[data-calculator-error]"
  );

  const resultTotal = root.querySelector(
    "[data-result-total]"
  );

  const resultSplit = root.querySelector(
    "[data-result-split]"
  );

  const resultNotes = root.querySelector(
    "[data-result-notes]"
  );

  const shareInput = root.querySelector(
    "#christ-wine-share"
  );

  const shareOutput = root.querySelector(
    "#christ-wine-share-output"
  );

  const shareHint = root.querySelector(
    "#christ-wine-share-hint"
  );

  const adultsInput = root.querySelector(
    "#christ-adults"
  );

  const resultWhatsAppButton = root.querySelector(
    '[data-whatsapp-trigger="result"]'
  );

  const resultEmailButton = root.querySelector(
    '[data-email-trigger="result"]'
  );

  if (
    !form ||
    !resultBox ||
    !errorBox ||
    !resultTotal ||
    !resultSplit ||
    !resultNotes ||
    !shareInput ||
    !shareOutput ||
    !shareHint ||
    !adultsInput ||
    !resultWhatsAppButton ||
    !resultEmailButton
  ) {
    console.error(
      "Weingut-Christ-Rechner: Erforderliche HTML-Elemente fehlen."
    );

    return;
  }

  /*
   * Nummer und E-Mail werden erst im Browser zusammengesetzt.
   * Das verhindert kein professionelles Scraping, erschwert aber
   * sehr einfache automatische Abfragen des HTML-Codes.
   */
  const phoneParts = [
    "49",
    "6734",
    "8898"
  ];

  const emailParts = [
    "info",
    "weingut-christ.de"
  ];

  const whatsappNumber = phoneParts.join("");
  const emailAddress = emailParts.join("@");

  let latestCalculation = null;

  const typeLabels = {
    white: "Weißwein",
    rose: "Rosé",
    red: "Rotwein"
  };

  const seasonShares = {
    warm: {
      white: 0.50,
      rose: 0.30,
      red: 0.20
    },

    mild: {
      white: 0.45,
      rose: 0.20,
      red: 0.35
    },

    cool: {
      white: 0.35,
      rose: 0.10,
      red: 0.55
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) {
      return "noch offen";
    }

    const date = new Date(
      `${isoDate}T12:00:00`
    );

    if (Number.isNaN(date.getTime())) {
      return isoDate;
    }

    return new Intl.DateTimeFormat(
      "de-DE",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }
    ).format(date);
  };

  const updateWineShareText = () => {
    const adults = Math.max(
      0,
      Number.parseInt(
        adultsInput.value,
        10
      ) || 0
    );

    const percentage =
      Number.parseInt(
        shareInput.value,
        10
      ) || 0;

    const drinkers = Math.round(
      adults * percentage / 100
    );

    shareOutput.textContent =
      `${percentage} %`;

    shareHint.textContent =
      `Bei ${adults} Erwachsenen entsprechen ` +
      `${percentage} % ungefähr ${drinkers} Weintrinkern.`;
  };

  const allocateBottles = (
    total,
    selectedTypes,
    season
  ) => {
    const base =
      seasonShares[season] ||
      seasonShares.mild;

    const selectedWeight =
      selectedTypes.reduce(
        (sum, type) => {
          return sum + (base[type] || 0);
        },
        0
      );

    if (selectedWeight <= 0) {
      return {};
    }

    const raw = selectedTypes.map(
      (type) => ({
        type,
        value:
          total *
          (base[type] / selectedWeight)
      })
    );

    const allocation = {};
    let assigned = 0;

    raw.forEach(
      ({ type, value }) => {
        allocation[type] =
          Math.floor(value);

        assigned += allocation[type];
      }
    );

    raw
      .map(
        ({ type, value }) => ({
          type,
          remainder:
            value - Math.floor(value)
        })
      )
      .sort(
        (a, b) =>
          b.remainder - a.remainder
      )
      .slice(
        0,
        total - assigned
      )
      .forEach(
        ({ type }) => {
          allocation[type] += 1;
        }
      );

    return allocation;
  };

  const showError = (message) => {
    errorBox.textContent = message;

    errorBox.classList.add(
      "is-visible"
    );

    resultBox.classList.remove(
      "is-visible"
    );

    resultWhatsAppButton.disabled = true;
    resultEmailButton.disabled = true;
  };

  const clearError = () => {
    errorBox.textContent = "";

    errorBox.classList.remove(
      "is-visible"
    );
  };

  const renderResult = (
    calculation
  ) => {
    resultTotal.textContent =
      calculation.stillWineBottles;

    resultSplit.innerHTML = "";

    Object.entries(
      calculation.allocation
    ).forEach(
      ([type, bottles]) => {
        const card =
          document.createElement("div");

        card.className =
          "christ-landing__result-card";

        const strong =
          document.createElement("strong");

        strong.textContent =
          `${bottles} Fl.`;

        const label =
          document.createElement("span");

        label.textContent =
          typeLabels[type];

        card.append(
          strong,
          label
        );

        resultSplit.appendChild(card);
      }
    );

    if (
      calculation.seccoBottles > 0
    ) {
      const card =
        document.createElement("div");

      card.className =
        "christ-landing__result-card";

      const strong =
        document.createElement("strong");

      strong.textContent =
        `${calculation.seccoBottles} Fl.`;

      const label =
        document.createElement("span");

      label.textContent =
        "Secco für den Empfang";

      card.append(
        strong,
        label
      );

      resultSplit.appendChild(card);
    }

    resultNotes.innerHTML = "";

    const notes = [
      `${calculation.wineDrinkers} von ` +
      `${calculation.adults} Erwachsenen wurden ` +
      "als Weintrinker berücksichtigt.",

      "Die Weinmenge enthält bereits zehn Prozent Planungsreserve.",

      "Das Ergebnis ist eine Orientierung und keine Verbrauchsgarantie."
    ];

    if (
      calculation.totalWithSecco >= 24
    ) {
      notes.push(
        "Mit dieser Kalkulation wird die Schwelle " +
        "von 24 Flaschen für den kostenfreien " +
        "Standardversand erreicht."
      );
    } else {
      notes.push(
        "Bis zur Schwelle von 24 Flaschen fehlen " +
        `rechnerisch noch ${
          24 - calculation.totalWithSecco
        } Flaschen.`
      );
    }

    if (
      calculation.stillWineBottles >= 36
    ) {
      notes.push(
        "Die vorgeschlagene Mindestmenge für " +
        "eine Kommissionsvereinbarung ist erreicht."
      );
    }

    notes.forEach(
      (text) => {
        const item =
          document.createElement("li");

        item.textContent = text;

        resultNotes.appendChild(item);
      }
    );

    resultBox.classList.add(
      "is-visible"
    );

    resultWhatsAppButton.disabled = false;
    resultEmailButton.disabled = false;

    resultBox.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  };

  const calculate = () => {
    clearError();

    const formData =
      new FormData(form);

    const adults =
      Number.parseInt(
        formData.get("adults"),
        10
      );

    const wineShare =
      Number.parseInt(
        formData.get("wineShare"),
        10
      );

    const durationFactor =
      Number.parseFloat(
        formData.get("duration")
      );

    const otherDrinksFactor =
      Number.parseFloat(
        formData.get("otherDrinks")
      );

    const selectedTypes =
      formData.getAll("wineTypes");

    const reception =
      formData.get("reception") === "on";

    if (
      !Number.isFinite(adults) ||
      adults < 1 ||
      adults > 1000
    ) {
      showError(
        "Bitte gib eine gültige Zahl zwischen " +
        "1 und 1.000 erwachsenen Gästen ein."
      );

      return null;
    }

    if (
      selectedTypes.length === 0
    ) {
      showError(
        "Bitte wähle mindestens eine Weinart aus."
      );

      return null;
    }

    const wineDrinkers = Math.max(
      1,
      Math.round(
        adults * wineShare / 100
      )
    );

    const rawStillWineBottles =
      wineDrinkers *
      durationFactor *
      otherDrinksFactor *
      1.10;

    const stillWineBottles =
      Math.max(
        1,
        Math.ceil(
          rawStillWineBottles
        )
      );

    const seccoBottles =
      reception
        ? Math.max(
            1,
            Math.ceil(
              (adults * 0.10) / 0.75
            )
          )
        : 0;

    const allocation =
      allocateBottles(
        stillWineBottles,
        selectedTypes,
        formData.get("season")
      );

    const durationOption =
      root.querySelector(
        "#christ-duration option:checked"
      );

    const otherDrinksOption =
      root.querySelector(
        "#christ-other-drinks option:checked"
      );

    const seasonOption =
      root.querySelector(
        "#christ-season option:checked"
      );

    const calculation = {
      eventType:
        formData.get("eventType"),

      eventDate:
        formData.get("eventDate"),

      adults,

      wineShare,

      wineDrinkers,

      durationText:
        durationOption
          ?.textContent
          ?.trim() || "",

      otherDrinksText:
        otherDrinksOption
          ?.textContent
          ?.trim() || "",

      seasonText:
        seasonOption
          ?.textContent
          ?.trim() || "",

      selectedTypes,

      stillWineBottles,

      seccoBottles,

      totalWithSecco:
        stillWineBottles +
        seccoBottles,

      allocation,

      food:
        String(
          formData.get("food") || ""
        ).trim(),

      wishes:
        String(
          formData.get("wishes") || ""
        ).trim()
    };

    latestCalculation =
      calculation;

    renderResult(
      calculation
    );

    return calculation;
  };

  const buildGenericMessage = () => {
    return [
      "Hallo Familie Christ,",
      "",
      "wir planen eine Feier und möchten uns zur passenden Weinmenge und Weinauswahl beraten lassen.",
      "",
      "Anlass: ",
      "Datum: ",
      "Erwachsene Gäste: ",
      "Ungefähre Zahl der Weintrinker: ",
      "Speisen / Menü: ",
      "Besondere Wünsche, z. B. Kommission oder Weinkühler: ",
      "",
      "Könnt ihr uns dazu eine Empfehlung geben?"
    ].join("\n");
  };

  const buildResultMessage = (
    calculation
  ) => {
    const splitText =
      Object.entries(
        calculation.allocation
      )
        .map(
          ([type, bottles]) => {
            return (
              `${typeLabels[type]}: ` +
              `ca. ${bottles} Flaschen`
            );
          }
        )
        .join(", ");

    const lines = [
      "Hallo Familie Christ,",
      "",
      `wir planen eine ${calculation.eventType}.`,
      `Datum: ${formatDate(calculation.eventDate)}`,
      `Erwachsene Gäste: ${calculation.adults}`,
      `Geschätzte Weintrinker: ${calculation.wineDrinkers} ` +
        `(${calculation.wineShare} %)`,
      `Dauer: ${calculation.durationText}`,
      `Andere Getränke: ${calculation.otherDrinksText}`,
      `Jahreszeit: ${calculation.seasonText}`,
      "",
      `Kalkulator-Ergebnis: ca. ` +
        `${calculation.stillWineBottles} Flaschen Wein ` +
        "inklusive Reserve.",
      `Vorgeschlagene Aufteilung: ${splitText}.`
    ];

    if (
      calculation.seccoBottles > 0
    ) {
      lines.push(
        "Zusätzlich zum Empfang: ca. " +
        `${calculation.seccoBottles} Flaschen Secco.`
      );
    }

    if (
      calculation.food
    ) {
      lines.push(
        "",
        `Speisen / Menü: ${calculation.food}`
      );
    }

    if (
      calculation.wishes
    ) {
      lines.push(
        `Besondere Wünsche: ${calculation.wishes}`
      );
    }

    lines.push(
      "",
      "Könnt ihr die Menge und Auswahl bitte mit uns abstimmen?"
    );

    return lines.join("\n");
  };

  const getMessage = (
    source
  ) => {
    if (
      source === "result" &&
      latestCalculation
    ) {
      return buildResultMessage(
        latestCalculation
      );
    }

    return buildGenericMessage();
  };

  const openWhatsApp = (
    source
  ) => {
    const message =
      getMessage(source);

    const url =
      `https://wa.me/${whatsappNumber}` +
      `?text=${encodeURIComponent(message)}`;

    window.location.href = url;
  };

  const openEmail = (
    source
  ) => {
    const message =
      getMessage(source);

    const subject =
      source === "result" &&
      latestCalculation
        ? `Weinberatung für unsere ${latestCalculation.eventType}`
        : "Weinberatung für unsere Feier";

    const url =
      `mailto:${emailAddress}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(message)}`;

    window.location.href = url;
  };

  shareInput.addEventListener(
    "input",
    updateWineShareText
  );

  adultsInput.addEventListener(
    "input",
    updateWineShareText
  );

  form.addEventListener(
    "submit",
    (event) => {
      event.preventDefault();

      calculate();
    }
  );

  root
    .querySelectorAll(
      "[data-whatsapp-trigger]"
    )
    .forEach(
      (button) => {
        button.addEventListener(
          "click",
          () => {
            openWhatsApp(
              button.dataset
                .whatsappTrigger
            );
          }
        );
      }
    );

  root
    .querySelectorAll(
      "[data-email-trigger]"
    )
    .forEach(
      (button) => {
        button.addEventListener(
          "click",
          () => {
            openEmail(
              button.dataset
                .emailTrigger
            );
          }
        );
      }
    );

  updateWineShareText();
})();